/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Table_Downloadsize1Inputs */

const id_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuran Unduhan`)
};

const ms_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiz Muat Turun`)
};

const da_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Størrelse`)
};

const de_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download-Größe`)
};

const en_us2_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Size`)
};

const es_es2_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de descarga`)
};

const es_mx2_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de descarga`)
};

const fil_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sukat ng Download`)
};

const fr_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille du téléchargement`)
};

const it_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione download`)
};

const hu_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltési méret`)
};

const nl_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloadgrootte`)
};

const no_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedlastingsstørrelse`)
};

const pl_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozmiar do pobrania`)
};

const pt_br2_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho do download`)
};

const pt_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho de descarga`)
};

const ro_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiune descărcare`)
};

const fi_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latauskoko`)
};

const sv_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedladdningsstorlek`)
};

const vi_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kích thước tải xuống`)
};

const tr_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İndirme Boyutu`)
};

const cs_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velikost stažení`)
};

const bg_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер за изтегляне`)
};

const ru_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер загрузки`)
};

const uk_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розмір завантаження`)
};

const ar_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حجم التنزيل`)
};

const hi_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड आकार`)
};

const th_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขนาดดาวน์โหลด`)
};

const ja_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロードサイズ`)
};

const zh_cn2_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载大小`)
};

const zh_hant1_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載大小`)
};

const ko_builds_table_downloadsize1 = /** @type {(inputs: Builds_Table_Downloadsize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다운로드 용량`)
};

/**
* | output |
* | --- |
* | "Download Size" |
*
* @param {Builds_Table_Downloadsize1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_table_downloadsize1 = /** @type {((inputs?: Builds_Table_Downloadsize1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Table_Downloadsize1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_table_downloadsize1(inputs)
	if (locale === "ms") return ms_builds_table_downloadsize1(inputs)
	if (locale === "da") return da_builds_table_downloadsize1(inputs)
	if (locale === "de") return de_builds_table_downloadsize1(inputs)
	if (locale === "en-US") return en_us2_builds_table_downloadsize1(inputs)
	if (locale === "es-ES") return es_es2_builds_table_downloadsize1(inputs)
	if (locale === "es-MX") return es_mx2_builds_table_downloadsize1(inputs)
	if (locale === "fil") return fil_builds_table_downloadsize1(inputs)
	if (locale === "fr") return fr_builds_table_downloadsize1(inputs)
	if (locale === "it") return it_builds_table_downloadsize1(inputs)
	if (locale === "hu") return hu_builds_table_downloadsize1(inputs)
	if (locale === "nl") return nl_builds_table_downloadsize1(inputs)
	if (locale === "no") return no_builds_table_downloadsize1(inputs)
	if (locale === "pl") return pl_builds_table_downloadsize1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_table_downloadsize1(inputs)
	if (locale === "pt") return pt_builds_table_downloadsize1(inputs)
	if (locale === "ro") return ro_builds_table_downloadsize1(inputs)
	if (locale === "fi") return fi_builds_table_downloadsize1(inputs)
	if (locale === "sv") return sv_builds_table_downloadsize1(inputs)
	if (locale === "vi") return vi_builds_table_downloadsize1(inputs)
	if (locale === "tr") return tr_builds_table_downloadsize1(inputs)
	if (locale === "cs") return cs_builds_table_downloadsize1(inputs)
	if (locale === "bg") return bg_builds_table_downloadsize1(inputs)
	if (locale === "ru") return ru_builds_table_downloadsize1(inputs)
	if (locale === "uk") return uk_builds_table_downloadsize1(inputs)
	if (locale === "ar") return ar_builds_table_downloadsize1(inputs)
	if (locale === "hi") return hi_builds_table_downloadsize1(inputs)
	if (locale === "th") return th_builds_table_downloadsize1(inputs)
	if (locale === "ja") return ja_builds_table_downloadsize1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_table_downloadsize1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_table_downloadsize1(inputs)
	return ko_builds_table_downloadsize1(inputs)
});
export { builds_table_downloadsize1 as "builds.table.downloadSize" }